import { render, staticRenderFns } from "./ServiceBtn.vue?vue&type=template&id=62ead3c4&scoped=true"
import script from "./ServiceBtn.vue?vue&type=script&lang=js"
export * from "./ServiceBtn.vue?vue&type=script&lang=js"
import style0 from "./ServiceBtn.vue?vue&type=style&index=0&id=62ead3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ead3c4",
  null
  
)

export default component.exports